import React from 'react';
import { Button } from 'rsuite';
import { Link } from 'react-router-dom';

function MapView(props) {
  return (
    <div className={props.wrapperClass} style={{ top: 145 }}>
      <div>
        {props.selectedCruise.id == "1569adf5-c604-4958-bf0b-a20de2d6d341"
          ? <div className="max-w-lg">
            <img src="/img/Barcelona_roundtrip.jpg" alt="Map" />
            <div className="absolute" style={{ right:25, bottom: 100 }}>
              <Link to={"/details/" + props.token + "/" + props.selectedCruise.id} className="px-4 py-2 rounded bg-orange-500 text-white hover:bg-orange-600">
                See more
              </Link>
            </div>
          </div>
          : <h5 className="p-4 text-center">No map was found</h5>
        }
      </div>
      <div className="flex">
        <div className="p-4" >
          <Button
            onClick={props.handlePriceViewChange}
            color="orange" size="xs" appearance="subtle">
            <p className="underline">See prices</p>
          </Button>
        </div>
        <div className="p-4" >
          <Button
            onClick={props.handleDescriptionViewChange}
            color="orange" size="xs" appearance="subtle">
            <p className="underline">See description</p>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default MapView;